// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.memory-composer {
  color: var(--site-ink);
  font-size: 15px;
}
.memory-composer fieldset {
  padding: 0;
  margin: 0;
  border: 0;
  min-width: 0;
}
.composer-profile {
  margin: 0 0 18px;
  color: var(--site-muted);
  font-size: 14px;
}
.composer-modes {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 9px;
}
.composer-modes button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 7px;
  min-height: 78px;
  padding: 10px 5px;
  border: 1px solid var(--site-border);
  border-radius: 5px;
  background: #fff;
  color: #687c88;
  font-size: 14px;
}
.composer-modes.with-video {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.composer-video-preview {
  display: block;
  width: 100%;
  max-height: 320px;
  aspect-ratio: 16 / 9;
  margin-top: 14px;
  background: #111;
}
.composer-video-name {
  overflow-wrap: anywhere;
  font-size: 13px;
}
.composer-video-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.composer-modes button[aria-pressed='true'] {
  background: #eaf3fa;
  border-color: #86aac9;
  color: #416f9d;
  box-shadow: inset 0 0 0 1px #86aac9;
}
.composer-content {
  padding-top: 20px;
}
.composer-dropzone {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  min-height: 235px;
  border: 1px dashed #a0b9cc;
  border-radius: 6px;
  background: #f6fafc;
  color: #557d9b;
}
.composer-dropzone strong {
  font-size: 18px;
  font-weight: 600;
  margin-top: 3px;
}
.composer-dropzone span {
  font-size: 14px;
  color: #718794;
}
.composer-dropzone small {
  margin-top: 7px;
  font-size: 11px;
  color: #85949d;
}
.composer-dropzone.dragging,
.composer-photos.dragging {
  background: #e9f3ee;
  outline: 2px solid #719880;
  outline-offset: -2px;
}
.composer-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}
.composer-field {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 5px;
  margin-top: 18px;
  color: #566b78;
  font-size: 13px;
  font-weight: 500;
}
.composer-field small {
  font-size: 12px;
  color: #8a979f;
  font-weight: 400;
}
.composer-field input,
.composer-field textarea,
.composer-photo > input {
  display: block;
  flex: 0 0 100%;
  width: 100%;
  min-width: 0;
  padding: 11px 12px;
  border: 1px solid #cedce6;
  border-radius: 5px;
  background: #fff;
  color: var(--site-ink);
  font-size: 15px;
  line-height: 1.5;
}
.composer-field textarea {
  resize: vertical;
}
.composer-author {
  max-width: 380px;
}
.composer-photos {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 13px;
}
.composer-photo {
  min-width: 0;
}
.composer-photo-preview {
  position: relative;
  aspect-ratio: 4 / 3;
  background: #edf1f3;
  border-radius: 5px;
  overflow: hidden;
}
.composer-photo-preview img,
.composer-photo-preview video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.composer-video-badge {
  position: absolute;
  left: 6px;
  bottom: 6px;
  display: grid;
  place-items: center;
  width: 26px;
  height: 24px;
  background: #fffffff0;
  color: #527389;
  border-radius: 3px;
  pointer-events: none;
}
.composer-remove,
.composer-photo-status {
  display: grid;
  place-items: center;
  position: absolute;
  top: 7px;
  right: 7px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: #fffffff0;
  color: #527389;
}
.composer-photo-status {
  color: #3e7857;
}
.composer-photo-loading {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  background: #ffffff80;
  color: #416f9d;
}
.composer-photo-failed {
  position: absolute;
  left: 6px;
  bottom: 6px;
  font-size: 11px;
  background: #fff0ed;
  color: #a15848;
  padding: 2px 6px;
}
.composer-caption-button {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 7px 0;
  min-height: 32px;
  border: 0;
  background: transparent;
  color: #7b8d98;
  font-size: 12px;
  text-align: left;
}
.composer-caption-button svg {
  flex-shrink: 0;
}
.composer-caption-button span {
  overflow-wrap: anywhere;
}
.composer-photo > input {
  padding: 6px 8px;
  font-size: 12px;
  margin-top: 4px;
}
.composer-add-photo {
  display: grid;
  place-items: center;
  aspect-ratio: 4 / 3;
  border: 1px dashed #b0c5d5;
  border-radius: 5px;
  color: #5b81a0;
  background: #f4f9fc;
}
.composer-text-kind {
  display: inline-flex;
  border: 1px solid var(--site-border);
  border-radius: 5px;
  overflow: hidden;
}
.composer-text-kind button {
  min-height: 36px;
  padding: 6px 19px;
  border: 0;
  background: #fff;
  color: #72828d;
  font-size: 13px;
}
.composer-text-kind button[aria-pressed='true'] {
  color: #8d6055;
  background: #faefeb;
}
.composer-error {
  margin: 14px 0 0;
  font-size: 13px;
  color: #a45549;
  overflow-wrap: anywhere;
}
.composer-success,
.composer-link-valid {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 10px 0 0;
  color: #4c7e60;
  font-size: 13px;
}
.composer-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid var(--site-border);
}
.composer-footer p {
  margin: 0;
  font-size: 12px;
  color: #81919b;
}
.composer-footer button {
  flex-shrink: 0;
}
.composer-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
  font-size: 12px;
  color: #70858c;
}
.composer-progress progress {
  width: 170px;
  height: 6px;
  accent-color: #6d9b81;
}
.composer-spinner {
  animation: composer-spin 0.9s linear infinite;
}
@keyframes composer-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 600px) {
  .composer-modes.with-video {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .composer-modes {
    gap: 6px;
  }
  .composer-modes button {
    font-size: 12px;
    min-height: 74px;
  }
  .composer-photos {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }
  .composer-footer {
    flex-wrap: wrap;
    gap: 12px;
  }
  .composer-footer .site-button {
    width: 100%;
  }
  .composer-dropzone {
    min-height: 210px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .composer-spinner {
    animation: none;
  }
}
.contributor-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; margin-top: 16px; }
.contributor-fields .composer-field { margin: 0; min-width: 0; }
.contributor-fields select { width: 100%; min-width: 0; padding: 10px; border: 1px solid #cbd2d1; border-radius: 4px; background: #fff; color: #253d36; font: inherit; }
.contributor-access-note { grid-column: 1 / -1; font-size: 13px; line-height: 1.5; color: #52615d; margin: 0; }
.contributor-email-option { display: flex; gap: 9px; align-items: center; flex-wrap: wrap; margin-top: 16px; font-size: 14px; }
.contributor-email-option input { width: 17px; height: 17px; flex: none; }
@media (max-width: 500px) { .contributor-fields { grid-template-columns: minmax(0, 1fr); } }
`, "",{"version":3,"sources":["webpack://./src/AddMemory.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,UAAU;EACV,SAAS;EACT,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;;;EAGE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,gDAAgD;IAChD,SAAS;EACX;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA,sBAAsB,aAAa,EAAE,gDAAgD,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACpH,sCAAsC,SAAS,EAAE,YAAY,EAAE;AAC/D,6BAA6B,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,aAAa,EAAE;AACvK,2BAA2B,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AAC9G,4BAA4B,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC9H,kCAAkC,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE;AACzE,4BAA4B,sBAAsB,qCAAqC,EAAE,EAAE","sourcesContent":[".memory-composer {\n  color: var(--site-ink);\n  font-size: 15px;\n}\n.memory-composer fieldset {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  min-width: 0;\n}\n.composer-profile {\n  margin: 0 0 18px;\n  color: var(--site-muted);\n  font-size: 14px;\n}\n.composer-modes {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 9px;\n}\n.composer-modes button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 7px;\n  min-height: 78px;\n  padding: 10px 5px;\n  border: 1px solid var(--site-border);\n  border-radius: 5px;\n  background: #fff;\n  color: #687c88;\n  font-size: 14px;\n}\n.composer-modes.with-video {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n.composer-video-preview {\n  display: block;\n  width: 100%;\n  max-height: 320px;\n  aspect-ratio: 16 / 9;\n  margin-top: 14px;\n  background: #111;\n}\n.composer-video-name {\n  overflow-wrap: anywhere;\n  font-size: 13px;\n}\n.composer-video-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.composer-modes button[aria-pressed='true'] {\n  background: #eaf3fa;\n  border-color: #86aac9;\n  color: #416f9d;\n  box-shadow: inset 0 0 0 1px #86aac9;\n}\n.composer-content {\n  padding-top: 20px;\n}\n.composer-dropzone {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 9px;\n  width: 100%;\n  min-height: 235px;\n  border: 1px dashed #a0b9cc;\n  border-radius: 6px;\n  background: #f6fafc;\n  color: #557d9b;\n}\n.composer-dropzone strong {\n  font-size: 18px;\n  font-weight: 600;\n  margin-top: 3px;\n}\n.composer-dropzone span {\n  font-size: 14px;\n  color: #718794;\n}\n.composer-dropzone small {\n  margin-top: 7px;\n  font-size: 11px;\n  color: #85949d;\n}\n.composer-dropzone.dragging,\n.composer-photos.dragging {\n  background: #e9f3ee;\n  outline: 2px solid #719880;\n  outline-offset: -2px;\n}\n.composer-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n.composer-field {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 5px;\n  margin-top: 18px;\n  color: #566b78;\n  font-size: 13px;\n  font-weight: 500;\n}\n.composer-field small {\n  font-size: 12px;\n  color: #8a979f;\n  font-weight: 400;\n}\n.composer-field input,\n.composer-field textarea,\n.composer-photo > input {\n  display: block;\n  flex: 0 0 100%;\n  width: 100%;\n  min-width: 0;\n  padding: 11px 12px;\n  border: 1px solid #cedce6;\n  border-radius: 5px;\n  background: #fff;\n  color: var(--site-ink);\n  font-size: 15px;\n  line-height: 1.5;\n}\n.composer-field textarea {\n  resize: vertical;\n}\n.composer-author {\n  max-width: 380px;\n}\n.composer-photos {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 13px;\n}\n.composer-photo {\n  min-width: 0;\n}\n.composer-photo-preview {\n  position: relative;\n  aspect-ratio: 4 / 3;\n  background: #edf1f3;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.composer-photo-preview img,\n.composer-photo-preview video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.composer-video-badge {\n  position: absolute;\n  left: 6px;\n  bottom: 6px;\n  display: grid;\n  place-items: center;\n  width: 26px;\n  height: 24px;\n  background: #fffffff0;\n  color: #527389;\n  border-radius: 3px;\n  pointer-events: none;\n}\n.composer-remove,\n.composer-photo-status {\n  display: grid;\n  place-items: center;\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: #fffffff0;\n  color: #527389;\n}\n.composer-photo-status {\n  color: #3e7857;\n}\n.composer-photo-loading {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  background: #ffffff80;\n  color: #416f9d;\n}\n.composer-photo-failed {\n  position: absolute;\n  left: 6px;\n  bottom: 6px;\n  font-size: 11px;\n  background: #fff0ed;\n  color: #a15848;\n  padding: 2px 6px;\n}\n.composer-caption-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 7px 0;\n  min-height: 32px;\n  border: 0;\n  background: transparent;\n  color: #7b8d98;\n  font-size: 12px;\n  text-align: left;\n}\n.composer-caption-button svg {\n  flex-shrink: 0;\n}\n.composer-caption-button span {\n  overflow-wrap: anywhere;\n}\n.composer-photo > input {\n  padding: 6px 8px;\n  font-size: 12px;\n  margin-top: 4px;\n}\n.composer-add-photo {\n  display: grid;\n  place-items: center;\n  aspect-ratio: 4 / 3;\n  border: 1px dashed #b0c5d5;\n  border-radius: 5px;\n  color: #5b81a0;\n  background: #f4f9fc;\n}\n.composer-text-kind {\n  display: inline-flex;\n  border: 1px solid var(--site-border);\n  border-radius: 5px;\n  overflow: hidden;\n}\n.composer-text-kind button {\n  min-height: 36px;\n  padding: 6px 19px;\n  border: 0;\n  background: #fff;\n  color: #72828d;\n  font-size: 13px;\n}\n.composer-text-kind button[aria-pressed='true'] {\n  color: #8d6055;\n  background: #faefeb;\n}\n.composer-error {\n  margin: 14px 0 0;\n  font-size: 13px;\n  color: #a45549;\n  overflow-wrap: anywhere;\n}\n.composer-success,\n.composer-link-valid {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 10px 0 0;\n  color: #4c7e60;\n  font-size: 13px;\n}\n.composer-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  margin-top: 25px;\n  padding-top: 20px;\n  border-top: 1px solid var(--site-border);\n}\n.composer-footer p {\n  margin: 0;\n  font-size: 12px;\n  color: #81919b;\n}\n.composer-footer button {\n  flex-shrink: 0;\n}\n.composer-progress {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: 20px;\n  font-size: 12px;\n  color: #70858c;\n}\n.composer-progress progress {\n  width: 170px;\n  height: 6px;\n  accent-color: #6d9b81;\n}\n.composer-spinner {\n  animation: composer-spin 0.9s linear infinite;\n}\n@keyframes composer-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (max-width: 600px) {\n  .composer-modes.with-video {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .composer-modes {\n    gap: 6px;\n  }\n  .composer-modes button {\n    font-size: 12px;\n    min-height: 74px;\n  }\n  .composer-photos {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n  }\n  .composer-footer {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n  .composer-footer .site-button {\n    width: 100%;\n  }\n  .composer-dropzone {\n    min-height: 210px;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .composer-spinner {\n    animation: none;\n  }\n}\n.contributor-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px; margin-top: 16px; }\n.contributor-fields .composer-field { margin: 0; min-width: 0; }\n.contributor-fields select { width: 100%; min-width: 0; padding: 10px; border: 1px solid #cbd2d1; border-radius: 4px; background: #fff; color: #253d36; font: inherit; }\n.contributor-access-note { grid-column: 1 / -1; font-size: 13px; line-height: 1.5; color: #52615d; margin: 0; }\n.contributor-email-option { display: flex; gap: 9px; align-items: center; flex-wrap: wrap; margin-top: 16px; font-size: 14px; }\n.contributor-email-option input { width: 17px; height: 17px; flex: none; }\n@media (max-width: 500px) { .contributor-fields { grid-template-columns: minmax(0, 1fr); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
